import { lang } from '@umu/ukit-lang';
import { Iconfont } from '@umu/umu-design';
import React, { useMemo } from 'react';
import { UCourseRadar } from './uCourseRadar';
import { getAccessUrl } from '../../@utils/umuUtil';
import UMU_LOGO from './images/logo.png';
import UMU_LOGO_WHITE from './images/logo-white.png';
import './index.scss';

export interface IUCourseShareData {
    access_code: string;
    course_title: string;
    logo: string;
    logo_mobile: string;
    score: number;
    share_qrc: string;
    teacher_name: string;
    items: IUScoreItem[];
}
export interface IUScoreItem {
    type: number;
    score: number;
    name: string;
}
/** 分数评级 */
enum EScoreGrade {
    HIGH,
    MIDDLE,
    LOW,
}
interface IShareCardTypeContent {
    background: string;
    color: string;
    btnColor: string;
    mainColor: string;
}
export enum EShareCardType {
    YELLOW = 1,
    BLUE,
    GREEN,
}
const ShareCardTypeList: { [key in EShareCardType]: IShareCardTypeContent } = {
    [EShareCardType.YELLOW]: {
        background: 'linear-gradient(180deg, #FEBD2B 0%, #FFC748 100%)',
        color: '#683F01',
        btnColor: 'rgba(250, 180, 0, 0.9)',
        mainColor: '#FEBD2B',
    },
    [EShareCardType.BLUE]: {
        background: 'linear-gradient(180deg, #1E6EE6 0%, #2196F3 82.15%)',
        color: '#ffffff',
        btnColor: 'rgba(34, 151, 244, 0.9)',
        mainColor: '#1E6EE6',
    },
    [EShareCardType.GREEN]: {
        background: 'linear-gradient(180deg, #21A564 0%, #4CC087 100%)',
        color: '#ffffff',
        btnColor: 'rgba(33, 165, 100, 0.9)',
        mainColor: '#21A564',
    },
};
const SummaryTextList = {
    [EScoreGrade.HIGH]: [
        lang('课程结构科学、内容丰富、互动性强，整体设计非常符合学习科学原理。'),
        lang('课程整体设计非常符合学习科学原理。学习有效果、学习效率高、学习体验好。'),
        lang('课程为学员提供了充足有效的练习与反馈，能够帮助学员学以致用。'),
    ],
    [EScoreGrade.MIDDLE]: [
        lang('课程很好地应用了学习科学原理，能够帮助学员实现学以致用的学习效果。'),
        lang('课程很好地应用了学习科学原理。学员能在这门课程中有效学习、高效学习。'),
        lang('学员将在这门课程中获得很好的学习体验，保持高度的学习动力。'),
    ],
    [EScoreGrade.LOW]: [
        lang('课程已经开启了效果学习设计，快来一起看看哪里还能提升。'),
        lang('课程正在尝试利用学习科学的原理进行设计，快来一起看看有哪些改进方法。'),
        lang('这是一门将“学以致用”作为教学目标的课程，快来一起看看怎么提升学习效果。'),
    ],
};

interface IProps {
    themeId: EShareCardType;
    courseId?: string;
    data: IUCourseShareData;
}
export const UCourseShareCard = (props: IProps) => {
    const { themeId = EShareCardType.YELLOW, data } = props;

    const { background, color, btnColor, mainColor } = ShareCardTypeList[themeId];

    const { course_title, logo_mobile, teacher_name, score = 0, share_qrc, access_code, items } = data;
    const scoreGrade = score >= 80 ? EScoreGrade.HIGH : score >= 60 ? EScoreGrade.MIDDLE : EScoreGrade.LOW;

    const summaryText = useMemo(() => {
        return SummaryTextList[scoreGrade][Math.floor(Math.random() * 3)];
    }, []);

    const isYelloewTheme=themeId == EShareCardType.YELLOW;
    const logo=logo_mobile||(isYelloewTheme ? UMU_LOGO_WHITE : UMU_LOGO)

    return (
        <div className="u-course-share-card" style={{ background, color }}>
            <img src={logo} alt="umu" className="logo" />
            <div className="title">{course_title}</div>
            <div className="teacher">
                <Iconfont
                    type="Person"
                    className="icon"
                    style={{ color: isYelloewTheme? '#A26E1F' : '#ffffff' }}
                ></Iconfont>
                {teacher_name}
            </div>
            <div className="score-box">
                <div
                    className="score-text"
                    dangerouslySetInnerHTML={{ __html: lang('U课指数获得<span>{$0}</span>{$unit}', score).replace('{$unit}', lang('{$$0{0=分,1=分}}', String(score))) }}
                ></div>
                <div className="summary-text">{summaryText}</div>
                <div className="radar">
                    <UCourseRadar color={mainColor} uScoreItems={items} score={score} />
                </div>
            </div>
            <div className="share-box">
                <div className="left">
                    <div className="url">
                        <div>{lang('浏览器输入访问码直达课程')}</div>
                        <div>{getAccessUrl(access_code)}</div>
                    </div>
                    <div className="btn" style={{ background: btnColor }}>
                        {lang('识别二维码查看课程')}
                        <Iconfont type="SmallMore" className="right-arrow"></Iconfont>
                    </div>
                </div>
                <img className="u-course-qr-code" src={share_qrc}></img>
            </div>
        </div>
    );
};
